import styled from 'styled-components';

export const Page = styled.div`
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 64px 16px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    background: radial-gradient(
        circle at top center,
        hsl(var(--accent) / 0.08),
        transparent 30%
      ),
      radial-gradient(
        circle at bottom left,
        hsl(var(--primary) / 0.06),
        transparent 28%
      );
  }
`;

export const Orbs = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;

  .orb {
    position: absolute;
    width: 340px;
    height: 340px;
    border-radius: 999px;
    filter: blur(110px);
    opacity: 0.22;
  }

  .primary {
    top: 24%;
    left: -120px;
    background: hsl(var(--primary) / 0.28);
  }

  .sky {
    bottom: 18%;
    right: -120px;
    background: hsl(var(--accent) / 0.3);
  }
`;

export const Wrap = styled.div`
  width: 100%;
  max-width: 440px;
  position: relative;
  z-index: 1;
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 24px;

  .paw {
    width: 58px;
    height: 58px;
    border-radius: 18px;
    margin: 0 auto 14px;
    display: grid;
    place-items: center;
    background: linear-gradient(135deg, #f58a2a, #e9781d);
    color: #081018;
    box-shadow: 0 0 18px rgba(245, 138, 42, 0.32),
      0 0 46px rgba(245, 138, 42, 0.16);
  }

  h1 {
    font-size: 28px;
    font-weight: 900;
    letter-spacing: -0.03em;
  }

  p {
    margin-top: 8px;
    color: hsl(var(--muted-foreground));
    font-weight: 600;
  }
`;

export const FormCard = styled.div`
  position: relative;
  border-radius: 24px;
  padding: 28px;
  border: 1px solid hsl(var(--accent) / 0.16);
  background: radial-gradient(
      circle at top right,
      hsl(var(--accent) / 0.08),
      transparent 30%
    ),
    linear-gradient(
      180deg,
      hsl(var(--card) / 0.78),
      hsl(var(--background) / 0.86)
    );
  box-shadow: 0 24px 60px hsl(var(--background) / 0.5),
    0 0 0 1px hsl(var(--accent) / 0.05),
    inset 0 1px 0 hsl(var(--foreground) / 0.04);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: -1px;
    border-radius: 24px;
    pointer-events: none;
    background: hsl(var(--accent) / 0.08);
    opacity: 0.3;
  }

  &::after {
    content: '';
    position: absolute;
    inset: -14px;
    border-radius: 30px;
    pointer-events: none;
    background: hsl(var(--accent) / 0.12);
    filter: blur(28px);
    opacity: 0.45;
    z-index: -1;
  }
`;

export const Field = styled.div`
  margin-top: 14px;

  label {
    display: block;
    color: hsl(var(--muted-foreground));
    font-weight: 800;
    font-size: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 6px;
  }

  &.first {
    margin-top: 0;
  }
`;

export const Links = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;

  a {
    text-decoration: none;
  }

  .muted {
    color: hsl(var(--muted-foreground));
    font-weight: 700;
    font-size: 14px;
  }

  .muted:hover {
    text-decoration: underline;
    text-shadow: 0 0 10px hsl(var(--accent) / 0.18);
  }

  .sky {
    color: hsl(var(--accent));
    font-weight: 900;
    text-shadow: 0 0 10px hsl(var(--accent) / 0.18);
  }

  .sky:hover {
    text-decoration: underline;
    text-shadow: 0 0 12px hsl(var(--accent) / 0.42);
  }
`;
